<template>
  <div style="flex: 1">
    <div class="list-wrap">
      <div class="img-card">
        <q-img
          :src="
            $ossLimit(
              product.image ||
                'https://static.bakmigm.co.id/menu/00110000/Default.jpg',
            )
          "
          :ratio="1"
          spinner-color="primary"
        >
          <div
            v-if="!product.inStock"
            class="absolute-full text-subtitle2 flex flex-center"
            style="width: 64px"
          >
            <q-icon name="app:habisIcon" class="logo" size="30px" />
          </div>
        </q-img>
      </div>
      <div :class="{ disabled: !product.inStock }">
        <div class="prodInfo">
          <div
            break
            class="prodTitle dot2 text-bold font-size-16"
            v-html="productNameRes"
          />
          <div bold break class="price-normal">
            {{ $n(product.finalPrice, 'currency', 'id-ID') }}
          </div>
          <div v-if="promo" break class="price-del">
            {{ $n(product.listPrice, 'currency', 'id-ID') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    search: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showdata: [],
    };
  },
  computed: {
    productNameRes() {
      return this.ruleTitle(
        this.product.name,
        this.search.replace(/(^\s*)|(\s*$)/g, ''),
      );
    },
    promo() {
      return this.product.finalPrice !== this.product.listPrice;
    },
  },
  methods: {
    ruleTitle(str, highlight) {
      const reg = new RegExp(highlight, 'gim');
      const res = str.replace(
        reg,
        (val) => `<span class='search-text'>${val}</span>`,
      );
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-wrap {
  padding: 25px 0px 0px;
  display: flex;
  .img-card {
    width: 64px;
    height: 64px;
    margin-right: 12px;
    :deep(.q-img) {
      background-size: cover;
      width: 64px;
      height: 64px;
      border-radius: 8px;
    }
  }
  .prodInfo {
    font-family: GothamOffice;
    font-style: normal;
    font-size: 16px;
    line-height: 120%;
    display: flex;
    flex-direction: column;
    & > div + div {
      margin-top: 3px;
    }
    .prodTitle {
      font-weight: bold;
      :deep(.search-text) {
        color: #ff9e2d;
      }
    }
  }
}
.text-card-gray {
  color: #6b7280;
}
.bg-card-color {
  background: #eaecf5;
}

// =====
.price {
  &-normal {
    font-size: 14px;
  }
  &-del {
    font-size: 12px;
    color: $grayFont;
    text-decoration: line-through;
  }
}
</style>
